import type { RootState } from '@core/Store'

export const selectIsVisible = (state: RootState) => state.kambi.isVisible
export const selectIsLoggedIn = (state: RootState) => state.kambi.isLoggedIn
export const selectIsBetslipMaximized = (state: RootState) => state.kambi.isBetslipMaximized
export const selectLogoutToken = (state: RootState) => state.kambi.logoutToken
export const selectLoginPending = (state: RootState) => state.kambi.isLoginPending
export const selectIsKambiRendered = (state: RootState) => state.kambi.isKambiRendered
export const selectPlayerSessionId = (state: RootState) => state.kambi.playerSessionId
export const selectIsBrowserSupported = (state: RootState) => state.kambi.isBrowserSupported
export const getIsInSignUp = (state: RootState) => state.kambi.isInSignUp
export const getIsReloadPending = (state: RootState) => state.kambi.isReloadPending
